<template>
  <v-menu offset-y class="logged-user-menu z-index" absolute>
    <template v-slot:activator="{ on }">
      <v-list color="primary" class="pa-0">
        <v-list-item id="toolbar-menu" v-on="on">
          <v-avatar color="marca-0-l10" size="45">{{ $getLoggedUser().name && $getLoggedUser().name.charAt(0) }}</v-avatar>
          <mf-icon fill color="branco">keyboard_arrow_down</mf-icon>
        </v-list-item>
      </v-list>
    </template>
    <div class="menu-card">
      <h2>{{ userName }}</h2>
      <v-list>
        <v-list-item v-if="$isLogged() && !isAdmin" @click="redirect('/perfil')">
          <v-list-item-title>Notificações</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="hasPiiAccess && $getLoggedUser().admin" @click="redirect('/usuarios')">
          <v-list-item-title>Usuários</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAdmin" @click="redirect('/configuracoes-admin')">
          <v-list-item-title>Configurações</v-list-item-title>
        </v-list-item>
        <div class="separator" />
        <v-list-item id="logout" @click="logout">
          <v-list-item-title class="logout">
            Sair
            <mf-icon icon="logout" color="vermelho-d20" />
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
import { mapWaitingActions } from 'vue-wait'

import { formattedRedirectLogout } from '@/helpers/login'

export default {
  computed: {
    isAdmin() {
      return this.$getIsAdmin()
    },
    userName() {
      const name = this.$getLoggedUser().name
      return name.split(' ').splice(0, 2).toString().replace(',', ' ')
    },
  },
  methods: {
    ...mapWaitingActions({
      getUsuarios: 'users',
    }),
    redirect(path) {
      this.$router.push(path).catch(() => {})
    },
    goToStatusPage() {
      window.open('https://status.mercafacil.com', '_blank')
    },
    logout() {
      const singleLoginURL = this.$microservicesUrls['mfLogin']
      const host = location.href.slice(0, location.href.indexOf('#'))
      const hash = window.localStorage.getItem('redirectAfterLogin') || ''

      this.$logout()
      window.location.href = formattedRedirectLogout(singleLoginURL, host, hash)
    },
  },
}
</script>

<style lang="scss">
.user-name {
  white-space: nowrap;
}

.menu-card {
  min-width: 172px;
  background-color: $branco;
  h2 {
    padding: 10px;
    font-size: 14px;
    font-weight: 700;
    color: $cinza-d20;
    border-bottom: 1px solid $cinza-l70;
  }

  .v-list {
    border-radius: 0;
    box-shadow: none !important;
    padding: 0;

    .v-list-item {
      padding: 0 10px;
    }

    .v-list-item__title {
      font-weight: 400;
      font-size: 14px !important;
      line-height: 20px;
      color: $cinza-d20 !important;
    }

    .separator {
      width: calc(100% - 20px);
      height: 1px;
      background-color: $cinza-l70;
      margin: 0 auto;
    }

    .logout {
      color: $vermelho-d20 !important;
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }
}
</style>
